import React, {useState} from "react";
import "./Ressourcen/Calender.css"
import abbreviations from "./Ressourcen/abbreviations.json"
import {log} from "util";


function Slot({name, tag, job_duration, slot, filter_name}) {
    const slot_style = {border: "10%", display: "table", width: "100%",};
    const [isClicked, setIsClicked] = useState(false);
    const clicked_on_name = (id) => {
        filter_name({person_id: id}, null);
        for (let i = 0; i < slot.Allocations.length; i++) {
            if (name === abbreviateName(slot.Allocations[i].Caption)) {
                filter_name({person_id: slot.Allocations[i].IdAddress}, null)
            }
        }

    }
    //if (slot.Allocations.length > slot.Qty) slot.Qty = slot.Allocations.length
    //console.log(slot)

    const clicked_on_ressource = (ressource_id) => {
        filter_name({ressource_id: ressource_id}, null)
    }
    const [isExpanded, setisExpanded] = useState(false)

    const open_contact = (person) => {
        localStorage.setItem('person', JSON.stringify(person)); // Speichern der Daten in localStorage
        const url = '/contact';
        window.open(url, '_blank');
    }

    const clicked_on_open = () => {
        filter_name({open: 1}, null)
    }


    return (
        <div style={{paddingLeft: "3px"}}>
            <div className={`slots`} style={slot_style}>
                <div style={{
                    display: "table-row", Width: "100%", cursor: 'pointer'
                }} onClick={() => {
                    setisExpanded(!isExpanded)
                }}>
                    {slot.resource_type === null ? null : <p style={{
                        display: "table-cell", width: "36%", fontWeight: 'bold'
                    }}>{abbreviations[slot.resource_type] || slot.name}</p>}
                    <div style={{
                        display: "table-cell",
                        width: "34%",
                        paddingRight: "1%",
                        paddingLeft: "1%",
                        padding: "1px",
                    }}>
                        {[...Array(slot.Qty)].map((__, index) => {
                            if (slot.Allocations.length <= index) return <p key={index}
                                                                            style={{
                                                                                backgroundColor: "red",
                                                                                paddingLeft: "3px",
                                                                                borderRadius: "4px"
                                                                                , marginTop: "1px"
                                                                            }}>offen</p>
                            else {
                                if (parseInt(slot.Allocations[index].Color.substring(1), 16) > 255) return <p
                                    key={index}
                                    style={{
                                        backgroundColor: slot.Allocations[index].Color,
                                        paddingLeft: "3px", borderRadius: "4px", marginTop: "1px"
                                    }}>{abbreviateName(slot.Allocations[index].Caption)}</p>;
                                else return <p key={index}
                                               style={{
                                                   color: "white",
                                                   backgroundColor: slot.Allocations[index].Color,
                                                   paddingLeft: "2px", borderRadius: "4px", marginTop: "1px"
                                               }}>{abbreviateName(slot.Allocations[index].Caption)}</p>;


                            }


                        })}
                    </div>
                    {slot.startDate === null ? null : <p style={{
                        display: "table-cell", width: "30%"
                    }}>{new Date(slot.startDate.split('Z')[0]).toLocaleTimeString([], {
                        hour: '2-digit', minute: '2-digit'
                    })}-{new Date(slot.endDate.split('Z')[0]).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })}</p>}
                </div>
                {
                    !isExpanded ? null :
                        [...Array(slot.Qty)].map((__, index) => {
                            return (
                                slot.Allocations.length <= index ?
                                    <div key={index} style={{display: "table-row"}}>
                                        <p
                                            onClick={() => clicked_on_open()} style={{
                                            display: "table-cell",
                                            color: "black",
                                            textDecoration: "none",
                                            fontSize: '14px',
                                            cursor: "pointer"
                                        }}>🔎 Typ</p>
                                        <p onClick={() => clicked_on_open()}
                                           style={{
                                               display: "table-cell",
                                               color: "black",
                                               textDecoration: "none",
                                               fontSize: '14px',
                                               cursor: "pointer"
                                           }}>🔎 Offen </p>
                                    </div> :
                                    <div key={index} style={{display: "table-row"}}>
                                        <p
                                            onClick={() => clicked_on_ressource(slot.resource_type)} style={{
                                            display: "table-cell",
                                            color: "black",
                                            textDecoration: "none",
                                            fontSize: '14px',
                                            cursor: "pointer"
                                        }}>🔎 Typ</p>
                                        <p onClick={() => clicked_on_name(slot.Allocations[index].IdAddress)}
                                           style={{
                                               display: "table-cell",
                                               color: "black",
                                               textDecoration: "none",
                                               fontSize: '14px',
                                               cursor: "pointer"
                                           }}>🔎{slot.Allocations[index].Caption} </p>
                                        {slot.IdResourceType !== 1 ? null :
                                            <p onClick={() => {
                                                open_contact({IdAddress: slot.Allocations[index].IdAddress})
                                            }}
                                               style={{
                                                   display: "table-cell",
                                                   color: "black",
                                                   textDecoration: "none",
                                                   fontSize: '14px',
                                                   cursor: "pointer"
                                               }}>📱 Kontakt</p>}
                                    </div>)
                        })}
            </div>

            <div style={{display: "table-row", cursor: "default"}}>
                {slot.ressourcenbuchung1 == null ? <p></p> : <div>
                    <p style={{
                        width: "100%", color: "black", textDecoration: "none", fontSize: '14px',
                    }}>{slot.ressourcenbuchung1}</p>
                </div>}
            </div>
        </div>);
}

function abbreviateName(name) {
    if (name == null) name = "Error";
    const parts = name.split(" ");
    if (parts.length < 2) {
        return name; // Return the full name if only one part is present
    }
    const firstName = parts[0];
    if (firstName !== "") {
        const abbreviatedFirstName = firstName.charAt(0) + "."; // First letter of the first name with a dot
        return abbreviatedFirstName + " " + parts.slice(1).join(" "); // Concatenate the abbreviated first name with the last name
    }
    return  parts.join(" ")
}

export default Slot